import { render, staticRenderFns } from "./MultiSelectItem.vue?vue&type=template&id=6a769acb&"
import script from "./MultiSelectItem.vue?vue&type=script&lang=js&"
export * from "./MultiSelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports